import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';

@Component({
    selector: 'app-patients-badges',
    template: `

  <style>
    .du-flag-badge-btn {
      padding: 0px 3px;
      font-size: 7px;
      font-weight: 500;
      white-space: nowrap;
      color: #c04a36;
      background-color: #f2d3cd;
      border: 1px solid #c04a36;
      border-radius: 100px;
      vertical-align: super;
      line-height: 1;
      margin-left: 2px;
    }
  </style>

  <div style="white-space:normal; word-break:break-word;">
    {{ this.params?.value || '' }}<span
      *ngIf="this.params?.value &&
      this.params?.data &&
      this.flagBasedBadges?.column_nm &&
      this.params.data[this.flagBasedBadges?.column_nm] == 'Y'"
      class="du-flag-badge-btn"
      [style.background]="flagBasedBadges?.color + '33' || '#f2d3cd'"
      [style.border-color]="flagBasedBadges?.color || '#c04a36'"
      [style.color]="flagBasedBadges?.color || '#c04a36'">{{flagBasedBadges?.label || 'Raw'}}</span>
  </div>


  `,
    standalone: false
})
export class PatientsBadgesComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams | any;
  flagBasedBadges:any;

  constructor() {}
  
  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams<any>): void {
    this.params = params;
    this.flagBasedBadges = this.params.colDef.flagBasedBadges || {};
  }

}